import axios from '../../../lib/axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL.replace(/\/+$/, '') : '';

export const authService = {
  register: async (userData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/signup/`, userData);
      return response.data;
    } catch (error) {
      console.error('API Error - Signup failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login/mfa`, { email, password });
      // Store tokens if provided immediately
      if (response.data.access_token) {
        localStorage.setItem('accessToken', response.data.access_token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
      }
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
      return response.data;
    } catch (error) {
      console.error('API Error - Login failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  setupMfa: async (mfaToken) => {
    try {
      const payload = mfaToken ? { mfa_token: mfaToken } : {};
      const response = await axios.post(`${API_BASE_URL}/login/mfa/setup/`, payload);
      return response.data;
    } catch (error) {
      console.error('API Error - MFA Setup failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  verifyMfaSetup: async (mfaToken, otp) => {
    try {
      const payload = mfaToken ? { 
        mfa_token: mfaToken, 
        otp: otp,
        code: otp
      } : {
        otp: otp,
        code: otp
      };
      const response = await axios.post(`${API_BASE_URL}/login/mfa/setup/verify/`, payload);
      // Store tokens if provided
      if (response.data.access_token) {
        localStorage.setItem('accessToken', response.data.access_token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
      }
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
      return response.data;
    } catch (error) {
      console.error('API Error - Verify MFA Setup failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  verifyMfa: async (mfaToken, code) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login/mfa/verify/`, { mfa_token: mfaToken, code });
      // Store tokens if provided
      if (response.data.access_token) {
        localStorage.setItem('accessToken', response.data.access_token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
      }
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
      return response.data;
    } catch (error) {
      console.error('API Error - Verify MFA failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  sendEmailMfa: async (mfaToken) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login/mfa/email/send/`, { mfa_token: mfaToken });
      return response.data;
    } catch (error) {
      console.error('API Error - Send Email MFA failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  verifyEmailMfa: async (mfaToken, code) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login/mfa/email/verify/`, { mfa_token: mfaToken, code });
      // Store tokens if provided
      if (response.data.access_token) {
        localStorage.setItem('accessToken', response.data.access_token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
      }
      if (response.data.refresh_token) {
        localStorage.setItem('refreshToken', response.data.refresh_token);
      }
      return response.data;
    } catch (error) {
      console.error('API Error - Verify Email MFA failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },



  activateAccount: async (token, password, confirmPassword) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/activate-account/`, {
        token,
        password,
        confirm_password: confirmPassword,
      });
      return response.data;
    } catch (error) {
      console.error('API Error - Account activation failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  verifyActivationToken: async (token) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/activate-account/${token}/`);
      return response.data;
    } catch (error) {
      console.error('API Error - Token verification failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('rememberedEmail');
    localStorage.removeItem('loginTimestamp');
  },

  forgotPassword: async (email) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
      return response.data;
    } catch (error) {
      console.error('API Error - Forgot password failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  resetPassword: async (uid, token, password, confirmPassword) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/reset-password`, {
        uid,
        token,
        password,
        confirm_password: confirmPassword
      });
      return response.data;
    } catch (error) {
      console.error('API Error - Reset password failed:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },
};

// Mock service for development/testing
export const mockAuthService = {
  register: (data) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!data.email || !data.fullname) {
          reject(new Error('Email and fullname are required'));
        } else {
          resolve({ success: true, message: 'Registration successful' });
        }
      }, 1500);
    });
  },

  login: (email, password) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!email || !password) {
          reject(new Error('Email and password are required'));
        } else {
          resolve({ success: true, message: 'Login successful' });
        }
      }, 1500);
    });
  },



  activateAccount: (token, password, confirmPassword) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (password !== confirmPassword) {
          reject(new Error('Passwords do not match'));
        } else if (password.length < 8) {
          reject(new Error('Password must be at least 8 characters'));
        } else {
          resolve({ success: true, message: 'Account activated successfully' });
        }
      }, 1500);
    });
  },

  logout: () => {
  }
};